<template>
  <div class="bg-white shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
    <div class="px-4 mx-auto max-w-7xl 2xl:px-0">
      <form @submit.prevent="bulkEditCallQueue" method="POST">
        <div class="space-y-10">
          <div class="py-5">
            <div class="grid grid-cols-1 mt-5 gap-x-6 gap-y-8 sm:grid-cols-6">
              <div class="sm:col-span-3">
                <label for="default_destination_type" class="block text-sm font-medium leading-6 text-gray-900">
                  {{ $t("Type de destination par défaut en dehors des heures d'ouverture")}}
                </label>
                <div class="mt-2">
                  <select
                    v-model="destinationType"
                    min="0"
                    name="default_destination_type"
                    id="default_destination_type"
                    class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-green-600 sm:text-sm sm:leading-6"
                  >
                    <option
                      v-for="type in dest_type"
                      :key="type.value"
                      :value="type.value"
                    >
                      {{ $t(type.name) }}
                    </option>
                  </select>
                  <span v-if="errors.destinationType" class="text-red-600">
                    {{ errors.destinationType}}
                  </span>
                </div>
              </div>
              <div class="sm:col-span-3">
                <label for="default_destination" class="block text-sm font-medium leading-6 text-gray-900">
                  {{ $t("Destination par défaut en dehors des heures d'ouverture") }}
                </label>
                <div class="w-full">
                  <div class="relative">
                    <!-- <div
                    class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                    <SearchIcon class="w-5 h-5 text-gray-400" aria-hidden="true" />
                    class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                    <SearchIcon class="w-5 h-5 text-gray-400" aria-hidden="true" />
                    </div> -->
                    <div class="mt-2">
                      <span v-if="errors.default_destination" class="text-red-600">
                        {{ errors.default_destination}}
                      </span>
                      <div
                        v-if="
                        this.type === 'queue' ||
                        (this.type !== 'queue' && destinationType === 'external_number') ||
                        destinationType === 'call_queue'
                      ">
                        <input
                          v-model="searchDestNumber"
                          type="text"
                          name="default_destination"
                          id="default_destination"
                          :class="
                            ({ 'is-invalid': phoneError },
                            'block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-green-600 sm:text-sm sm:leading-6')
                          "
                        />
                        <span v-if="phoneError" class="error">{{ phoneError }}</span>
                        <span v-if="errors.default_destination" class="text-red-600">
                          {{ errors.default_destination}}
                        </span>
                      </div>
                      <div v-else-if="destinationType === 'end_call'">
                        <input
                          v-model="searchDestNumber"
                          type="text"
                          name="default_destination"
                          id="default_destination"
                          disabled=""
                          class="block w-full bg-gray-100 cursor-not-allowed rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-green-600 sm:text-sm sm:leading-6" 
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="mt-2">
                <input
                  v-model="destination"
                  min="0"
                  type="number"
                  name="default_destination"
                  id="default_destination"
                  class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-green-600 sm:text-sm sm:leading-6" />
                </div> -->
              </div>
              <div class="flex items-center justify-start col-span-full gap-3">
                <label for="active" class="block text-sm font-medium leading-6 text-gray-900">
                  {{ $t("active") }}
                </label>
                <div>
                  <input
                    v-model="this.form.active"
                    type="checkbox"
                    name="active"
                    id="active"
                    class="block border-gray-300 rounded shadow-sm focus:encom_border_input sm:text-sm"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex items-center justify-end pb-12 mt-6 gap-x-6">
          <button
            type="button"
            @click="this.$emit('closeForm')"
            class="px-3 py-2 text-sm font-semibold text-gray-900 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50"
          >
            {{ $t("ticket.cancel") }}
          </button>
          <button
            type="submit"
            class="px-3 py-2 text-sm font-semibold text-white rounded-md shadow-sm body__table--header"
          >
            {{ $t("ticket.send") }}
          </button>
        </div>
      </form>
    </div>
  </div>

  <ComfirmationDialog
    v-if="this.showMessage"
    :messageToShow="this.messageToShow"
    :subMessageToShow="this.subMessageToShow" 
  />
</template>

<script>
import VueSelect from "vue-next-select";
import "vue-next-select/dist/index.css";
import axios from "axios";
import ComfirmationDialog from "../components/ConfirmationDialog.vue";
import { SearchIcon } from "@heroicons/vue/outline";

const dest_type = [
 { name: "extension", value: "extension" },
 { name: "voicemail", value: "voicemail" },
 //  { name: "svi", value: "svi" },
 { name: "queue", value: "call_queue" },
 //  { name: "call flow", value: "call_flow" },
 { name: "end call", value: "end_call" },
 { name: "external number", value: "external_number" },
 { name: "other", value: "other" },
];

const account = localStorage.getItem("account");
export default {
  name: "BulkEditCallQueue",
  props: [
    "callQueuesGroups",
    "closeFormButton",
    "bulkEditData",
    "openBulkEditForm",
    "callQueuesOptions",
  ],
  components: {
    ComfirmationDialog,
    SearchIcon,
    VueSelect,
  },
  data() {
    return {
    phoneError: null,
    searchDestNumber: "",
    destNumber: null,
    searchNumber: "",
    account,
    dest_type,
    selectOptions: [],
    selectOptionsNumbers: [],
    closeForm: true,
    destinationType: null,
    destination: null,
    type: "queue",
    form: {
      destination: null,
      number: "",
      active: true,
    },
    showMessage: false,
    messageToShow: "",
    subMessageToShow: "",
    searchableTerm: "",
    extensionOptions: [],
    othersOptions: [],
    queueOptions: [],
    didOptions: [],
    optionOnSelectHost: {},
    errors: {
      destination: null,
      number: "",
    },
    };
  },
  methods: {
    bulkEditCallQueue() {
      axios
        .post(`${this.$cookie.getCookie("API")}/api/v1/callQueues/bulk/update`, 
          {
            ids: this.bulkEditData,
            customerAccount: account,
            payload: {
              active: this.form.active,
              default_destination_type: this.destinationType,
              default_destination: this.searchDestNumber?.value,
            },
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        )
        .then(res => {
          let msg = this.$t("elementCreatedSuccessfully", {
            element: this.$t("Règle entrante"),
          });
          this.$emit("activeBanner");
          this.$emit("success", true);
          this.$emit("successMsg", msg);
          this.cleanForm();
          this.$emit("closeForm");
          this.$emit("refreshQueueList");
        })
        .catch(error => {
          this.errorHandling(error);
          this.$emit("activeBanner");
          this.$emit("success", false);
          this.$emit("successMsg", this.errorDataResponse);
        });
    },
    sendMessage(msg, subMsg) {
      this.showMessage = true;
      this.messageToShow = msg;
      this.subMessageToShow = subMsg;
    },
    cleanForm() {
      this.form.active = true;
      this.form.number = "";
      this.destinationType = null;
      this.searchDestNumber = null;
    },
    fillDest() {
      let data =
        Object.keys(this.optionOnSelectHost).length > 0
        ? this.optionOnSelectHost
        : this.callQueuesOptions;
      Object.keys(data?.extensions).forEach(val => {
        let obj = {};
        obj["value"] = val;
        obj["label"] = data?.extensions[val];
        this.extensionOptions.push(obj);
      });
      Object.keys(data?.queues).forEach(val => {
        let objQueue = {};
        objQueue["value"] = val;
        objQueue["label"] = data?.queues[val];
        this.queueOptions.push(objQueue);
      });
      Object.keys(data?.others).forEach(val => {
        let objOther = {};
        objOther["value"] = val;
        objOther["label"] = data?.others[val];
        this.othersOptions.push(objOther);
      });
    },
    fillOptions() {
      let queues = [];
      let dids = [];
      let data =
        Object.keys(this.optionOnSelectHost).length > 0
        ? this.optionOnSelectHost
        : this.callQueuesOptions;
      if (data && Object.keys(data).length > 0) {
        Object.keys(data?.queues).forEach(val => {
        let obj = {};
        obj["value"] = val;
        obj["label"] = data?.queues[val];
        queues.push(obj);
        });
        Object.keys(data?.dids).forEach(val => {
        let obj = {};
        if (data?.used_dids.indexOf(val) < 0) {
          obj["value"] = val;
          obj["label"] = data?.dids[val];
          dids.push(obj);
        }
        if (this.openUpdateForm && this.editData && this.editData?.did_number) {
          if (val == this.editData?.did_number) {
          obj["value"] = val;
          obj["label"] = data?.dids[val];
          dids.push(obj);
          }
        }
        });
        switch (this.type) {
        case "did":
          this.selectOptionsNumbers = dids;
          if (this.openUpdateForm && this.editData) {
          if (this.selectOptionsNumbers?.length) {
            let filteredArrDid = this.selectOptionsNumbers?.filter(
            res => res.value == this.editData?.did_number
            );
            this.searchNumber = filteredArrDid.length > 0 ? filteredArrDid[0] : "";
          }
          }
          break;
        case "queue":
          this.selectOptionsNumbers = queues;
          if (this.openUpdateForm && this.editData) {
          if (this.selectOptionsNumbers?.length) {
            let filteredArr = this.selectOptionsNumbers?.filter(
            res => res.value == this.editData?.number
            );
            this.searchNumber = filteredArr.length > 0 ? filteredArr[0] : "";
          }
          }
          break;

        default:
          console.log("Unknown action");
          break;
        }
      }
    },
  },
  watch: {
    type: function (val) {
      this.selectOptionsNumbers = [];
      this.fillOptions();
    },
    searchNumber: function (val) {
      this.form.number = val?.value;
    },
    searchDestNumber: function (val) {
      if (this.destinationType === "external_number") {
        this.validatePhoneNumber();
        this.destNumber = val;
        this.form.destination = val;
      } else {
        this.destNumber = val?.value;
        this.form.destination = val?.value;
      }
    },
    destinationType: function (val) {
      switch (val) {
        case "extension":
        this.selectOptions = this.extensionOptions;
        if (this.openUpdateForm && this.editData) {
          if (this.selectOptions?.length) {
          this.searchDestNumber = this.selectOptions?.filter(
            res => res.value == this.editData?.default_destination
          )[0];
          }
        }
        break;
        case "voicemail":
        this.selectOptions = this.extensionOptions;
        if (this.openUpdateForm && this.editData) {
          if (this.selectOptions?.length) {
          this.searchDestNumber = this.selectOptions?.filter(
            res => res.value == this.editData?.default_destination
          )[0];
          }
        }
        break;
        case "other":
        this.selectOptions = this.othersOptions;
        if (this.openUpdateForm && this.editData) {
          if (this.selectOptions?.length) {
          this.searchDestNumber = this.selectOptions?.filter(
            res => res.value == this.editData?.default_destination
          )[0];
          }
        }
        break;
        case "call_queue":
        this.selectOptions = this.queueOptions;
        if (this.openUpdateForm && this.editData) {
          if (this.selectOptions?.length) {
          this.searchDestNumber = this.selectOptions?.filter(
            res => res.value == this.editData?.default_destination
          )[0];
          }
        }
        break;
        case "call_flow":
        // this.selectOptions = extensions;
        break;
        case "end_call":
        // this.selectOptions = extensions;
        break;
        case "external_number":
        this.searchDestNumber = "";
        if (this.openUpdateForm && this.editData) {
          this.searchDestNumber = this.editData?.default_destination;
        }
        // this.selectOptions = extensions;
        break;
        default:
        console.log("Unknown action");
        break;
      }
    },
  },
  mounted() {
    if (this.callQueuesOptions) {
    this.fillOptions();
    this.fillDest();
    }
  },
  computed: {
  },
};
</script>

<style scoped>
.is-invalid {
  border-color: red;
}
.error {
  color: red;
  font-size: 0.875em;
}
</style>
